import type { BioBlock } from './model';

/** An adjacent, identical heading becomes the link's heading instead of repeating its title. */
export function presentBioBlocks(blocks: BioBlock[]) {
  const visible = blocks.filter((block) => block.visible);
  const repeatsNextTitle = (index: number) => {
    const heading = visible[index];
    const link = visible[index + 1];
    return (
      heading?.type === 'heading' &&
      link?.type === 'link' &&
      heading.title.trim() === link.title.trim()
    );
  };
  return visible.flatMap((block, index) =>
    repeatsNextTitle(index) ? [] : [{ block, heading: repeatsNextTitle(index - 1) }],
  );
}
